<div class="data-table__content" >
    <a *ngIf="params && params.value" 
        class="data-table__content-link" 
        target="_self" 
        (click)="showFilePreview($event)">{{file.Name}}
    </a>
</div>
